//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'Values',
  computed: {
    headings() {
      return [
        'Empathy',
        'Authenticity',
        'Growth mindset',
        'Boldness & courage',
        'Data-centricity',
        'Focus, speed & discipline',
      ];
    },
    headingClass() {
      return (index) => `fc-heading-2 values__column-${(index % 3) + 1}`;
    },
  },
};
